<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

import AppNav from './AppNav.vue';
import { useBodyScrollLock } from '@/composables/useIsMobile';
import { useLocalePath } from '@/composables/useLocalePath';

const route = useRoute();
const { localeRoute } = useLocalePath();
const { lock, unlock } = useBodyScrollLock();

const menuOpen = ref(false);

function toggleMenu() {
  menuOpen.value = !menuOpen.value;

  if (menuOpen.value) {
    lock();
    // The old implementation animated to the top with a 16ms setInterval loop;
    // the browser does this natively.
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    unlock();
  }
}

// A tap on a nav link is a navigation, so the overlay has to close itself —
// previously every link was a full page load, which did that implicitly.
watch(
  () => route.fullPath,
  () => {
    if (menuOpen.value) {
      menuOpen.value = false;
      unlock();
    }
  },
);
</script>

<template>
  <header class="header">
    <div class="header-content">
      <RouterLink :to="localeRoute('home')" class="logo">
        <div class="logo-img"></div>
        <div class="logo-text"></div>
      </RouterLink>

      <AppNav />

      <button
        type="button"
        class="mobile-menu-btn"
        :class="{ open: menuOpen }"
        :aria-expanded="menuOpen"
        aria-controls="mobile-nav"
        @click="toggleMenu"
      >
        <div class="mobile-burger"></div>
        <span class="closed-text">{{ $t('generic.menu') }}</span>
        <span class="open-text">{{ $t('generic.close') }}</span>
      </button>
    </div>

    <div id="mobile-nav" class="mobile-nav-content" :class="{ open: menuOpen }">
      <div class="content">
        <AppNav device="mobile" />
      </div>
      <div class="stripes"></div>
    </div>

    <div class="stripes"></div>
  </header>
</template>
